import axios from "axios";
import { ENVIRONMENT_URLS, ENVIRONMENT } from "constants/environment"

export function ownershipInviteLoadAction(params) {
    return async () => {
        const ENV = ENVIRONMENT_URLS[ENVIRONMENT];
        const { inviteCode } = params;
        return await axios.get(`${ENV}/invites/ownershipInvite/?code=${inviteCode}`);
    };
}